export default {
  topNav: {
    cadLabel: '鞋样设计CAD',
    fbjLabel: '放版切割机',
    cqjLabel: '智能裁切机'
  },

  w1: {
    label1: '简单易学',
    label2: '事半功倍',
    label3: '一站式服务'
  },

  clientArea: {
    sectionTitle: '心系客户，服务至上'
  },

  softwareFeature: {
    subTitleLeft: '替代手工，省时省力',
    titleLeft: '样层制版、扩缩级放',
    introLeft: '童鞋、运动鞋、老爹鞋给您分分钟制版、取版、改版，简单操作，高效便捷；制版完成后，扩缩级放一步到位，选号、单号、分片输出；',
    btnLeft: '发现更多',
    subTitleRight: '就是要简单！',
    titleRight: '灵活的样版操作方式',
    introRight: '丰富多样的快捷键，减轻操作流程，两步变一步，直奔主题，节省大量的操作时间和精力，使得样版在制作及修改上轻松省力；',
    btnRight: '预约免费体验',
  },

  machineFeature: {
    subTitleLeft: '热销中！',
    titleLeft: '全新系列产品 FC-1653',
    list: ['热销全国100+地区','完美搭配经纬鞋样制版切割','售后保障，一站式服务'],
    subTitleRight: '板房的专属用品',
    titleRight: '快速切割、高效放版',
    introRight: '根据电脑上设计好的鞋样图形，在纸板等材料上快速切割出想要的纸样，精度高、速度快，极大地减轻版师们的手工工作；',
    btnRight: '新年特惠，来电咨询',
    tableLabel: ['型号','幅面','厚度','传输','材料'],
    machineType: 'FC-1653C，FC-1653CA，FC-1653SE',
    cuttingArea: '923*618mm',
    cuttingDepth: '≤2mm',
    dataTransfer: '网口，并口',
    cuttingMaterial: '纸板，塑料板，牛皮纸，PVC'
  },

  news: {
    sectionLabel: '最新动态',
    btnPd: '发布时间',
    btnRm: '阅读更多'
  },

  about: {
    companyName: '申普科技 Shenpusoft.',
    companyDesc: '专业从事鞋样设计及扩缩CAD/CAM系统、数控切割设备的开发和应用',
    companyIntroL1: '温州申普科技有限公司成立于2002年，集软件硬件研发、销售和服务为一体的科技企业；',
    companyIntroL2: '多年鞋业市场的深入了解和经验累积，我们不断吸取和总结鞋样设计师们的手工经验，并实地学习各种鞋类的设计与制作过程，使得申普在产品上不断完善，带给企业更优良的自动化解决方案；'
  },

  contact: {
    sectionLabel: '联系我们',
    location: '中国浙江省温州市鹿城区集邦国际2楼221室',
    emailLabel: '邮箱',
    callLabel1: '客服热线',
    callLabel2: '销售热线',
    friendLabel: '友情链接',
    wechatLabel: '客服微信扫一扫'
  }
}